import { render, staticRenderFns } from "./ButtonMain.vue?vue&type=template&id=88a949b6&scoped=true&"
import script from "./ButtonMain.vue?vue&type=script&lang=js&"
export * from "./ButtonMain.vue?vue&type=script&lang=js&"
import style0 from "./ButtonMain.vue?vue&type=style&index=0&id=88a949b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a949b6",
  null
  
)

export default component.exports